import { render } from "./GlucoseList.vue?vue&type=template&id=98182920&scoped=true"
import script from "./GlucoseList.vue?vue&type=script&lang=js"
export * from "./GlucoseList.vue?vue&type=script&lang=js"

import "./GlucoseList.vue?vue&type=style&index=0&id=98182920&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98182920"]])

export default __exports__